import { Link } from "react-router-dom";
import Fbar from "../../assets/FBAR.png"
export default function FbarFactaFiling() {
  return (
    <>
      {/* Spacer for sticky header */}
      <div  />{/* Header spacing style={{ height: 72 }}*/}

      {/* Hero Banner */}
      <section className="py-5 bg-white position-relative overflow-hidden">
        <div className="container py-4">
          <div className="row align-items-center gx-5">
            <div className="col-lg-7">
              <h1
                className="fw-bold mb-3"
                style={{
                  fontFamily: "'Poppins',sans-serif",
                  color: "#2e3d9c",
                  fontSize: "2.4rem",
                  lineHeight: 1.19,
                }}
              >
                FBAR <span style={{
                  background: "linear-gradient(90deg, #6b46c1, #d53f8c 85%)",
                  color: "transparent",
                  WebkitBackgroundClip: "text",
                  backgroundClip: "text"
                }}>and FATCA</span>
              </h1>
              <p className="fs-5 text-secondary mb-0" style={{ maxWidth: 540 }}>
                Protect yourself and your business—stay compliant with U.S. foreign account reporting regulations. Our expert guidance ensures you avoid penalties, maintain transparency, and strengthen your global standing.
              </p>
            </div>
            <div className="col-lg-5 text-center d-none d-lg-block">
              <img
                src={Fbar}
                alt="Global Compliance"
                className="img-fluid rounded shadow"
                style={{ maxHeight: 280, objectFit: "cover" }}
              />
            </div>
          </div>
        </div>
        {/* Decorative background circle */}
        {/* <div
          aria-hidden="true"
          className="position-absolute top-0 end-0 opacity-15"
          style={{ width: 130, height: 130, background: "linear-gradient(135deg, #6B46C1, #D53F8C)", borderRadius: "50%", filter: "blur(16px)" }}
        /> */}
      </section>

      {/* Main FBAR and FATCA Info */}
      <section className="pt-4 pb-0" style={{ background: "#fafbff" }}>
        <div className="container">
          <div className="row g-4">
            {/* FBAR */}
            <div className="col-md-6">
              <div className="card border-0 shadow h-100 p-4 rounded-4">
                <div className="mb-3">
                  <span className="d-inline-flex align-items-center justify-content-center rounded-circle icon-52" style={{ background: "#e1e2fa" }}>
                    <i className="bi bi-shield-lock fs-2 text-primary"></i>
                  </span>
                </div>
                <h4 className="fw-semibold mb-2" style={{ color: "#2e3d9c" }}>Foreign Bank Account Report (FBAR)</h4>
                <p style={{ color: "#444" }}>
                  Also known as <b>FinCEN Form 114</b>, the FBAR must be filed <b>annually</b> by U.S. persons (citizens, residents, entities) who have financial interests in or authority over foreign accounts exceeding <b>$10,000</b> at any point during the year.<br />
                  <span className="text-danger fw-semibold">Non-compliance may result in severe civil and criminal penalties.</span>
                </p>
              </div>
            </div>
            {/* FATCA */}
            <div className="col-md-6">
              <div className="card border-0 shadow h-100 p-4 rounded-4">
                <div className="mb-3">
                  <span className="d-inline-flex align-items-center justify-content-center rounded-circle icon-52" style={{ background: "#fae1f2" }}>
                    <i className="bi bi-globe2 fs-2" style={{ color: "#d53f8c" }}></i>
                  </span>
                </div>
                <h4 className="fw-semibold mb-2" style={{ color: "#d53f8c" }}>Foreign Account Tax Compliance Act (FATCA)</h4>
                <p style={{ color: "#444" }}>
                  FATCA counters offshore tax evasion by requiring U.S. persons to report foreign assets on <b>Form 8938</b> if the value exceeds $50,000 (single) or $100,000 (joint).<br />
                  This is filed with your annual tax return. <span className="text-danger fw-semibold">Failing to report can incur significant penalties.</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Key Benefits/Reasons (creative row of icons) */}
      <section className="py-5" style={{ background: "#fff" }}>
        <div className="container">
          <div className="row text-center g-4">
            <div className="col-md-3 col-6">
              <div className="p-3">
                <span className="d-inline-flex align-items-center justify-content-center mb-2 rounded-circle bg-primary bg-opacity-10 icon-54">
                  <i className="bi bi-exclamation-circle-fill fs-3 text-primary"></i>
                </span>
                <div className="fw-semibold mb-1" style={{ color: "#6B46C1" }}>Avoiding Penalties</div>
                <p className="mb-0 small text-secondary">
                  Correct filing avoids steep fines—even criminal charges.
                </p>
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div className="p-3">
                <span className="d-inline-flex align-items-center justify-content-center mb-2 rounded-circle bg-pink-100 icon-54" style={{ background: "#fae1f2" }}>
                  <i className="bi bi-ban fs-3" style={{ color: "#d53f8c" }}></i>
                </span>
                <div className="fw-semibold mb-1" style={{ color: "#d53f8c" }}>Preventing Tax Evasion</div>
                <p className="mb-0 small text-secondary">
                  Regulatory frameworks protect against illegal offshore holdings.
                </p>
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div className="p-3">
                <span className="d-inline-flex align-items-center justify-content-center mb-2 rounded-circle bg-info bg-opacity-10 icon-54">
                  <i className="bi bi-check2-circle fs-3 text-info"></i>
                </span>
                <div className="fw-semibold mb-1" style={{ color: "#278cbd" }}>Ensuring Transparency</div>
                <p className="mb-0 small text-secondary">
                  Keep your global finances compliant and fully transparent.
                </p>
              </div>
            </div>
            <div className="col-md-3 col-6">
              <div className="p-3">
                <span className="d-inline-flex align-items-center justify-content-center mb-2 rounded-circle bg-success bg-opacity-10 icon-54">
                  <i className="bi bi-people-fill fs-3 text-success"></i>
                </span>
                <div className="fw-semibold mb-1" style={{ color: "#31926A" }}>Facilitating Global Business</div>
                <p className="mb-0 small text-secondary">
                  Foster trust and reputation for businesses with worldwide operations.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Simple Call to Action */}
      <section className="py-5 bg-light text-center">
        <div className="container">
          <h2 className="fw-bold mb-3" style={{
            fontFamily: "'Poppins',sans-serif",
            color: "#2e3d9c"
          }}>Need Help with FBAR or FATCA Filing?</h2>
          <p className="fs-5 mb-4 text-secondary" style={{ maxWidth: 540, margin: "0 auto" }}>
            Nexen Consulting’s compliance experts make international tax reporting seamless and stress-free—protecting your wealth and reputation while ensuring full legal compliance.
          </p>
          <div className="d-flex justify-content-center">
            <Link
              to="/contact"
              className="btn btn-lg rounded-pill fw-bold text-white px-5 py-3"
              style={{
                background: 'linear-gradient(90deg, #6B46C1, #D53F8C)',
                boxShadow: '0 4px 15px rgba(213,63,140,0.45)',
                transition: 'transform 0.3s, box-shadow 0.3s',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = 'scale(1.05)';
                e.currentTarget.style.boxShadow = '0 8px 30px rgba(213,63,140,0.7)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(213,63,140,0.45)';
              }}
            >
              Get In Touch
            </Link>
          </div>
        </div>
      </section>

      {/* Bootstrap Icons CDN (ensure available if not imported globally) */}
      <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.3/font/bootstrap-icons.css" />

    </>
  );
}
